<template>
  <v-card class="text-center ma-3 py-3 px-5" elevation="1">
    <v-icon size="64" color="primary">{{ icon }}</v-icon>
    <v-card-text class="black--text subtitle-2">
      <h1 :class="`${color}--text py-1`" v-if="!progress">{{ title }}</h1>
      <div v-else>
        <v-progress-circular :width="1" indeterminate />
      </div>
      {{ keterangan }}
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'InfoCard',
  props: {
    progress: {
      type: Boolean,
      required: false,
    },
    icon: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      default: 'primary',
    },
    keterangan: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped></style>
